const LOAD_DEFAULT_QEMIS_SEC = (state) => {
  state.school_dt.res = -1
  state.school_dt.scod = ''
  state.school_dt.schENG = ''
  state.school_dt.schKH = ''
  state.school_dt.proENG = ''
  state.school_dt.proKH = ''
  state.school_dt.disENG = ''
  state.school_dt.disKH = ''
  state.school_dt.comENG = ''
  state.school_dt.comKH = ''
  state.school_dt.fid = ''      // forign key ID
  state.type_code = ''
  state.school_dt.g7 = ''
  state.school_dt.g8 = ''
  state.school_dt.g9 = ''
  state.school_dt.g10 = ''
  state.school_dt.g11 = ''
  state.school_dt.g18 = ''
  state.school_dt.g12 = ''
  state.school_dt.g19 = ''
  state.school_dt.pho_num = ''  // telephone number
  state.school_dt.sco_g7 = null
  state.school_dt.sco_g8 = null
  state.school_dt.sco_g9 = null
  state.school_dt.sco_g10 = null
  state.school_dt.sco_g11 = null
  state.school_dt.sco_g18 = null
  state.school_dt.sco_g12 = null
  state.school_dt.sco_g19 = null
  /*
  state.school_dt.sco_g7.length = 0
  for (let i = 0; i < 10; i++) { // each grade have 10 subjects
    state.school_dt.sco_g7.push(state.score)
  }
  state.school_dt.sco_g8.length = 0
  for (let i = 0; i < 10; i++) { // each grade have 10 subjects
    state.school_dt.sco_g8.push(state.score)
  }
  state.school_dt.sco_g9.length = 0
  for (let i = 0; i < 10; i++) { // each grade have 10 subjects
    state.school_dt.sco_g9.push(state.score)
  }
  state.school_dt.sco_g10.length = 0
  for (let i = 0; i < 10; i++) { // each grade have 10 subjects
    state.school_dt.sco_g10.push(state.score)
  }
  state.school_dt.sco_g11.length = 0
  for (let i = 0; i < 10; i++) { // each grade have 10 subjects
    state.school_dt.sco_g11.push(state.score)
  }
  state.school_dt.sco_g18.length = 0
  for (let i = 0; i < 10; i++) { // each grade have 10 subjects
    state.school_dt.sco_g18.push(state.score)
  }
  state.school_dt.sco_g12.length = 0
  for (let i = 0; i < 10; i++) { // each grade have 10 subjects
    state.school_dt.sco_g12.push(state.score)
  }
  state.school_dt.sco_g19.length = 0
  for (let i = 0; i < 10; i++) { // each grade have 10 subjects
    state.school_dt.sco_g19.push(state.score)
  }
  */
}

const LOAD_DATA_QEMIS_SEC = (state, payload) => {
  state.school_dt = payload
}

export {
  LOAD_DEFAULT_QEMIS_SEC,
  LOAD_DATA_QEMIS_SEC
}
